import React from 'react';
import './tyc.css'

const TyC = () => {
    const termsAndConditions = [
        {
            title: "1. Introducción",
            content: "Estos Términos y Condiciones rigen el uso del AI Pricing Analytics Assistant. Al utilizar este servicio, aceptas cumplir con todas las condiciones aquí descritas. Ten en cuenta que los precios sugeridos son solo una guía y deberán ser validados por el usuario final."
        },
        {
            title: "2. Uso del Servicio",
            content: "El asistente proporciona recomendaciones basadas en datos. Aunque se esfuerza por ser preciso, no garantizamos la exactitud absoluta de los resultados. Los precios sugeridos deben ser considerados como una guía y es responsabilidad del usuario final validarlos antes de su implementación."
        },
        {
            title: "3. Privacidad y Seguridad",
            content: "La privacidad y seguridad de tus datos se heredan de los SLA, reglas y políticas de seguridad de AWS y los servicios utilizados en la arquitectura del agente, como S3, Lambda, PostgreSQL y Bedrock. Además, los datos recopilados a través del asistente se utilizan exclusivamente para mejorar la precisión de las recomendaciones. No compartimos tus datos con terceros sin tu consentimiento explícito."
        },
        {
            title: "4. Limitaciones de Responsabilidad",
            content: "No seremos responsables por pérdidas o daños derivados del uso del asistente. El usuario final es responsable de validar los precios sugeridos antes de tomar decisiones comerciales."
        },
        {
            title: "5. Modificaciones",
            content: "Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones serán efectivas desde el momento de su publicación en esta página."
        },
        {
            title: "6. Contacto",
            content: "Para cualquier duda o aclaración sobre estos términos, puedes contactarnos a través de tu Asesor."
        }
    ];

    return (
        <div className="tyc-container">
            <h1>Términos y Condiciones</h1>
            <div className="tyc-list">
                {termsAndConditions.map((section, index) => (
                    <div key={index} className="tyc-item">
                        <h3 style={{ color: '#0b59ac' }}>{section.title}</h3>
                        <p>{section.content}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TyC;